module.exports = __webpack_public_path__ + "static/media/lucid-login-logo.46bcdb24.svg";